
export class updateRouting {
    static readonly type = '[RoutingUpdate] RoutingUpdate';

    constructor(public payload: string) {
    }
}   